// extracted by mini-css-extract-plugin
export default {"wrapper":"Slidebar_wrapper__tFdJS"};